// extracted by mini-css-extract-plugin
module.exports = {"root":"Gallery_root__3pvWL","placeholder":"Gallery_placeholder__2Q3rN"};